import styled, { css } from "styled-components";

export const EventTimer = styled.div`
  width: 50.81px;
  height: 50.81px;
  background: #fff;
  box-shadow: 0 0 0 1.2px #42464c;
  border-radius: 100%;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  position: relative;
  &.critical {
    border: 4px solid #d93333 !important;
  }
  path {
    stroke: #42464c;
    stroke-width: 1.5px;
  }

  ${({ status }) =>
    status === "doing"
      ? css`
          background-color: #f9e169;
        `
      : status === "pending"
      ? css`
          background-color: #fff;
        `
      : status === "done"
      ? css`
          background-color: #a0f69e;
        `
      : css`
          background-color: #fff;
        `}
`;

export const RemaingTime = styled.span`
  position: absolute;
  cursor: pointer;
  transform: translateX(calc(-50% + 25px));
  width: 150px;
  bottom: -30px;
  color: #42464c;
  background-color: #fff;
  text-align: center;
  font-family: Sora;
  font-size: 12px;
  font-weight: 600;
`;
